import { Component, OnInit } from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

declare var document: any;
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  constructor(private meta: Meta, private title: Title) {
    document.body.scrollTop = 0;
  }

  ngOnInit(): void {
    this.title.setTitle('IrvineTek | Agility. Integrity. Teamwork');
    // Google / Search Engine Tags
    this.meta.updateTag({ property: 'name', content: 'IrvineTek | Agility. Integrity. Teamwork' });
    this.meta.updateTag({ property: 'description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'image', content: 'https://irvinetek.com/assets/images/logo.png' });
    // Facebook Meta Tags
    this.meta.updateTag({ property: 'og:url', content: 'https://irvinetek.com/' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:title', name: 'title', content: 'IrvineTek | Agility. Integrity. Teamwork' });
    this.meta.updateTag({ property: 'og:description', name: 'description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'og:image', name: 'image', content: 'https://irvinetek.com/assets/images/logo.png' });
    // Twitter Meta Tags
    this.meta.updateTag({ property: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ property: 'twitter:title', content: 'IrvineTek | Agility. Integrity. Teamwork' });
    this.meta.updateTag({ property: 'twitter:description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'twitter:image', content: 'https://irvinetek.com/assets/images/logo.png' });

  }

}
